import React from "react";

import {styled} from "styled-components";

import {IconButton} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import FilterableName from "common_components/flowmaster/llm_run/filtering/filterable_name";
import ListLink from "common_components/flowmaster/llm_run/styled/ListLink";

import {OrganisationId} from "common/types/organisation";
import {AggregatedWorkflowTest} from "common/flowmaster/types/test";
import {LlmRunFilterKeys} from "common/flowmaster/types/llm_run";
import {LlmRunQueryParams} from "routes/llm_run/utils/filtering/get_llm_run_query_params";

const LinkIdentifier = styled.span`
  font-size: 14px;
  font-weight: 600;
  position: absolute;
  left: -3px;
    left: 18px;
    color: rgb(0, 0, 0, 0.54);
    top: 16px;
}
`;

type Props = {
  organisationId: OrganisationId;
  test: AggregatedWorkflowTest;
  filters?: LlmRunQueryParams;
  updateValue: (
    obj: Partial<Record<LlmRunFilterKeys, string | number>>,
  ) => void;
  hideCols: Set<"Workflow" | "Issue">;
};

export default function TestsTableRow({
  organisationId,
  test,
  updateValue,
  hideCols,
}: Props) {
  const queryString = Object.entries({
    workflow: test.workflow_id,
    project: test.project_id,
    document: test.document_id,
  })
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  return (
    <tr>
      {!hideCols.has("Workflow") && (
        <td>
          <FilterableName
            name={test.workflow_name}
            url={`organisation/${organisationId}/workflow/${test.workflow_id}`}
            filter={() => updateValue({workflow: test.workflow_id})}
          />
        </td>
      )}
      {!hideCols.has("Issue") && (
        <td>
          <div>
            <FilterableName
              name={
                <div>
                  <div>{test.issue_name ?? test.config_name}</div>
                  <div style={{fontSize: "0.75em"}}>{test.config_date}</div>
                </div>
              }
              url={`organisation/${organisationId}/data-asset/${test.workflow_id}/config/${test.config_id}`}
              filter={() =>
                updateValue({
                  workflow: test.workflow_id,
                  config: test.config_id,
                })
              }
            />
          </div>
        </td>
      )}
      <td>
        <FilterableName
          name={test.project_name}
          url={`organisation/${organisationId}/project/${test.project_id}`}
          filter={() => updateValue({project: test.project_id})}
        />
      </td>
      <td>
        <FilterableName
          name={`${test.document_name.substring(0, 100)}${
            test.clause_reference ? ` (Clause ${test.clause_reference})` : ""
          }`}
          url={`organisation/${organisationId}/project/${test.project_id}/document/${test.document_id}`}
          filter={() =>
            updateValue({
              project: test.project_id,
              document: test.document_id,
            })
          }
        />
      </td>
      <td>
        {(test.latest_llm_run_time ?? "")
          .toString()
          .replace("T", " ")
          .replace(/\..*/, "")}
      </td>
      <td style={{textAlign: "right"}}>{test.run_count}</td>
      <td style={{textAlign: "right"}}>
        {(Math.round(test.average_all_pass_score * 100 * 100) / 100).toFixed(2)}
        %
      </td>
      <td style={{textAlign: "right"}}>
        {(Math.round(test.average_score * 100 * 100) / 100).toFixed(2)}%
      </td>
      <td>
        <div style={{display: "flex"}}>
          <span style={{position: "relative"}}>
            <ListLink
              to={`/organisation/${organisationId}/llm_run/${test.latest_llm_run_id}/detail`}
            >
              <IconButton size="small" style={{padding: 0}}>
                <LinkIcon />
              </IconButton>
              <LinkIdentifier>L</LinkIdentifier>
            </ListLink>
          </span>
          <span style={{position: "relative"}}>
            <ListLink
              to={`/organisation/${organisationId}/llm_run/list?${queryString}`}
            >
              <IconButton size="small" style={{padding: 0}}>
                <LinkIcon />
              </IconButton>
              <LinkIdentifier>All</LinkIdentifier>
            </ListLink>
          </span>
          {test.is_data_asset && (
            <span style={{position: "relative"}}>
              <ListLink
                to={`/organisation/${organisationId}/data-assets/definition/${test.workflow_id}/config/${test.config_id}/asset/${test.latest_llm_run_id}?project=${test.project_id}&document=${test.document_id}`}
              >
                <IconButton size="small" style={{padding: 0}}>
                  <LinkIcon />
                </IconButton>
                <LinkIdentifier>DA</LinkIdentifier>
              </ListLink>
            </span>
          )}
        </div>
      </td>
    </tr>
  );
}
